<template>
  <ModalComponent ref="modal">
    <template #titleText>
      <div class="max-w-full w-[450px]">Confirmez votre email</div>
    </template>
    <template #subtitleText>
      <div class="max-w-full w-[450px]">
        Confirmez que l'email {{ email }} vous appartient
      </div>
    </template>

    <div class="flex flex-col">
      <div class="">
        Nous avons envoyé une otp de confirmation sur votre adresse
        {{ email }}
      </div>
      <div class="">Veuillez renseiller l'otp reçu</div>
      <form @submit.prevent="validateOtp">
        <InputComponent
          v-model="otpReceived"
          type="number"
          placeHolder="OTP Reçu"
        />
      </form>
      <div class="flex justify-center">
        <button
          class="underline text-blue-500"
          :class="{ 'opacity-60 ': !canResendOtp }"
          @click="tryResendOtp"
        >
          Renvoyer le code
        </button>
      </div>
      <div class="py-4"></div>

      <button class="buttonComponent arrow w-full" @click="validateOtp">
        Confirmer le code
      </button>
    </div>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '@/components/utils/InputComponent.vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'
import { OtpUtils } from '@/utils/plugins/otpUtils'

export default defineComponent({
  name: 'ProfileContent',
  components: { InputComponent, ModalComponent },
  props: {},
  data() {
    return {
      email: '',
      firstName: '',
      otpReceived: '',
      displayMessage: '',
      canResendOtp: false,
      otpResendRefreshTimeout: 0,
      otpResetTime: 0,
      validationId: '',
      reason: '',
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    async validateEmail({ email, firstName, reason, validationId }) {
      this.email = email
      this.firstName = firstName
      this.reason = reason || 'none'
      this.validationId = validationId || ''
      this.otpReceived = ''
      this.displayMessage = ''
      this.canResendOtp = false
      this.otpResetTime = 0
      this.otpResendRefreshTimeout = 0
      
      this.$Events.dispatchEvent('start_loading')
      const { sent } = await OtpUtils.sendOtp(email, firstName)
      this.$Events.dispatchEvent('finish_loading')
      if (!sent) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Veuillez réessayer',
          body: "Echec d'envoie de code otp pour vérifier votre compte. Veuillez réessayer",
        })
        return
      }
      await new Promise(r => setTimeout(r, 500))
      this.$refs.modal.show()
      this.refreshOtpResendDelay()
      this.step++
    },
    refreshOtpResendDelay() {
      this.canResendOtp = false
      clearTimeout(this.otpResendRefreshTimeout)
      const { delayInMs, timestamp } = OtpUtils.getOtpDelay()
      this.otpResetTime = timestamp
      if (delayInMs <= 0) {
        this.canResendOtp = true
        return
      }
      this.otpResendRefreshTimeout = setTimeout(() => {
        this.canResendOtp = true
      }, delayInMs)
    },
    tryResendOtp() {
      this.refreshOtpResendDelay()
      if (!this.canResendOtp) {
        const { delayInMs, timestamp } = OtpUtils.getOtpDelay()
        const delayMin = Math.ceil(delayInMs / 1000 / 60)
        this.$Events.dispatchEvent('toast_notification', {
          body: `Veuillez patienter ${delayMin} minute${
            delayMin > 1 ? 's' : ''
          } avant de demander un renvoie du code otp`,
        })
        return
      }
      this.resetOtp()
    },
    async resetOtp() {
      this.$Events.dispatchEvent('start_loading')
      const response = await OtpUtils.resendOtp(this.email, this.firstName)
      this.$Events.dispatchEvent('finish_loading')
      if (!response.sent) {
        this.$Events.dispatchEvent('toast_notification', {
          body: "Echec d'envoie du OTP, veuillez réessayer",
        })
        return
      }
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Otp Renvoyé',
      })
      this.refreshOtpResendDelay()
    },
    async validateOtp() {
      const { confirmed, expired } = await OtpUtils.confirmOtp(
        this.otpReceived,
        this.email,
      )
      if (expired) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Expiré',
          body: 'Veuillez demander un nouveau code Otp',
        })
        return
      }
      if (!confirmed) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Incorrect',
          body: 'Le code entré est incorrect',
        })
        return
      }
      this.$emit('otp_validated', {
        validationId: this.validationId,
        reason: this.reason,
        email: this.email,
        userName: this.userName,
      })
      this.$refs.modal.hide()

      this.$Events.dispatchEvent('toast_notification', {
        body: 'Code correct.',
      })
    },
  },
  watch: {},
})
</script>
